__webpack_require__.p = "/new-coin-hub/";